<template>
  <div class="enterprise-list-page enterprise-list-page--rooms">
    <!-- Header Card -->
        <PageHeader icon="fas fa-door-open">
      <template #title>
        Daftar Ruangan {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola pembagian ruangan, poli, laboratorium, serta fasilitas ruang rawat inap
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/masters/rooms/add')"
                v-if="btn">
                <i class="fas fa-plus"></i>
                <span>Tambah Ruangan</span>
              </b-button>
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>

            <modern-filter-bar
              embedded
              single-line
              :show-timeseries="false"
              :search-text.sync="filter.name"
              search-placeholder="Cari ruangan"
              @search-keyup="filterByName"
            >
              <template #before-search>
                <div class="modern-filter-select">
                  <treeselect
                    :multiple="false"
                    :options="buildings"
                    v-model="filter.building_id"
                    placeholder="Semua gedung"
                    @select="filterByBuilding"
                  />
                </div>
              </template>
            </modern-filter-bar>

            <!-- Table -->
            <medhop-data-table summary-title="Daftar Ruangan"
              striped
              hover
              class="mt-3"
              :items="items"
              :fields="fields"
              :style="'white-space: nowrap'"
              responsive="sm">
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '15%' : '' }" />
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="$router.push({ path: '/masters/rooms/detail/' + data.item.id, })"><i class="fas fa-eye px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="$router.push({ path: '/masters/rooms/edit/' + data.item.id, })"
                  v-if="btn"><i class="fas fa-edit px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  v-if="btn && data.item.is_ss_default == 0"><i class="fas fa-trash px-0"></i></b-button>
              </template>
            </medhop-data-table>
            <medhop-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"></medhop-pagination>
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

export default {

  name: "List",

  components: {
    Card,
  },

  data() {
    return {
      // Filter
      filter: {
        name: '',
        building_id: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "floor",
          label: "Lantai",
          sortable: true,
        },
        {
          key: "building_name",
          label: "Gedung",
          sortable: true,
        },
        // {
        //   key: "description",
        //   label: "Deskripsi",
        //   sortable: true,
        // },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // Options
      buildings: [],
      // user access
      btn: false,
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}&building_id=${this.filter.building_id}`
      let response = await module.paginate('rooms', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }

      this.items = response.data
    },

    async filterByBuilding(evt) {
      await this.filter.building_id
      this.currentPage = 1
      this.pagination()
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1
        this.pagination()
      }, 500)
    },

    async getBuildingOptions() {
      let response = await module.setTreeSelect("buildings")
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.buildings = response.data
        this.buildings.unshift({ label: "Filter Berdasar Gedung", id: "", isDisabled: true, })
      }
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("rooms/" + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "1802") {
          this.btn = true
        }
      }
    },
  },

  watch: {
    'filter.building_id': function (newVal, oldVal) {
      if (typeof newVal === 'undefined') {
        this.filter.building_id = ''
        this.filterByBuilding()
      }
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Ruangan" }])
    // Get Data    
    this.getBuildingOptions()
    this.pagination()
    this.setActiveButton()
  },

}
</script>
